// extracted by mini-css-extract-plugin
export default {"button":"newsletter-button-module__button__i6d8L","active":"newsletter-button-module__active__zybRF"};